import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

import LoadingSpinnerComponent from '../LoadingSpinnerComponent';

//@ts-ignore
import '../../styles/sentiment-gauge.scss';

import { Typography } from '@mui/joy';
import { useAuth } from '../../context/authContext';
import InfoTooltipComponent from '../InfoTooltipComponent';

const networking = require('../../Networking/API');

function SentimentGaugeComponent(app: any) {
    const { token } = useAuth();

    const [loading, setLoading] = useState(true);
    const [reviews, setReviews] = useState(null) as any[];

    var rotation = 0;

    if (!reviews) {
        getData();
    }

    function getData() {
        networking.reviewsFor(app.app.id, token).then((reviews: any) => {
            setReviews(reviews);
            setLoading(false);
        }).catch((error: Error) => {
            setLoading(false);
        });
    }

    if (reviews) {
        const badReviews = reviews.filter((d: any) => d.sentiment === 'bad').length;
        const goodReviews = reviews.filter((d: any) => d.sentiment === 'good').length;

        const total = reviews.length;

        const badPercentage = badReviews / total;
        const goodPercentage = goodReviews / total;

        const sentimentValue = goodPercentage * 100 - badPercentage * 100; // This will be between -100 and 100

        rotation = sentimentValue; // Scale to -100 to 100
    }

    var options: ApexOptions = {
        chart: {
            height: 200,
            type: 'radialBar',
            offsetY: -10
        },
        dataLabels: {
            enabled: false,
        },
        plotOptions: {
            radialBar: {
                startAngle: -135,
                endAngle: 135,
                dataLabels: {
                    name: {
                        show: false,
                    },
                    value: {
                        fontSize: '52px',
                        formatter: function (val) {
                            return val.toFixed(0);
                        }
                    }
                },
            },
        },
        fill: {
            type: 'solid',
            colors: [rotation! > 20 ? '#008000' : rotation! > 0 ? '#FFA500' : '#FF0000'],
        },
        stroke: {
            dashArray: 4
        },
        labels: ['Sentiment'],
    };

    return (
        <div>
            {loading ?
                <LoadingSpinnerComponent />
                :
                <div className='text-center'>
                    <Typography
                        color='neutral'
                        fontWeight={600}
                        level='body-xs'>
                        {"Net Sentiment Score".toUpperCase()}
                        <InfoTooltipComponent
                            message={"The Net Sentiment Score is calculated as the difference between the percentage of positive and negative reviews. A score above 0 indicates more positive sentiment, while a score below 50 indicates more negative sentiment."}
                            size={'sm'}
                            variant={'plain'}
                            color={'primary'} />
                    </Typography>
                    {rotation &&
                        <ReactApexChart
                            options={options}
                            series={[rotation + 50]}
                            type="radialBar"
                            height={350} />
                    }
                </div>
            }
        </div >
    )
}

export default SentimentGaugeComponent;